(function($){

	$(".layout-pricing .price-switcher").on("change", function() {
		var $pricingTable = $(this).closest('table.pricing');
		if ($(this).is(":checked")) {
			$pricingTable.find('.product-price .monthly').hide();
			$pricingTable.find('.product-price .yearly').show();
		} else {
			$pricingTable.find('.product-price .monthly').show();
			$pricingTable.find('.product-price .yearly').hide();
		}
	})

})(jQuery);